import {getFunctions, httpsCallable} from 'firebase/functions';
import {app} from './firebase';
// Notifications are best effort AFTER commit. Never embed bot credentials in browser code.
export async function sendTelegram(message) {
  if (process.env.REACT_APP_ENABLE_TELEGRAM !== 'true') return {ok: false, disabled: true};
  try {
    const result = await httpsCallable(getFunctions(app, 'asia-south1'), 'sendHotelNotification')({message: String(message || '').slice(0, 4000)});
    return result.data;
  } catch (error) {
    console.warn('Notification delivery failed:', error.code || 'unavailable');
    return {ok: false};
  }
}
